// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"23":"61a361dba99524f2","383":"e2cfe249691c3af2","449":"9668cb683b8194a4","639":"f9d49b0c752e82df","946":"60ca604356af2201"}[chunkId] + ".js";
};